import { render } from "./brandIntroduction.vue?vue&type=template&id=8a9091aa&scoped=true"
import script from "./brandIntroduction.vue?vue&type=script&lang=js"
export * from "./brandIntroduction.vue?vue&type=script&lang=js"

import "./brandIntroduction.vue?vue&type=style&index=0&id=8a9091aa&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9091aa"]])

export default __exports__